var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-dialog-bg"},[_c('div',{staticClass:"link-dialog"},[_c('div',{staticClass:"close",on:{"click":_vm.clickClose}}),_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm.clickCopy}},[_vm._v(" 点击复制下载链接 ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('div',[_vm._v("电脑壁纸需在元气桌面电脑版中使用")]),_c('div',[_vm._v("请复制链接, 在电脑浏览器打开并下载")])])
}]

export { render, staticRenderFns }